import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {PivotGrid as DXPivotGrid} from 'devextreme-react';
import {omit} from "ramda";


export default class PivotGrid extends Component {
    constructor(props) {
        super(props);

        this.onCellClick = this.onCellClick.bind(this);
    }

    onCellClick(e) {
        // console.log('onRowUpdating', e)
        const {setProps} = this.props;

        // console.log('onCellClick', e)
        if (e.rowType === 'data' && setProps) {
            setProps({
                cellClick: {
                    area: e.area,
                    rowType: e.rowType,
                    cell: {
                        columnPath: e.row.columnPath,
                        dataIndex: e.row.dataIndex,
                        expanded: e.row.expanded,
                        path: e.row.path,
                        rowPath: e.row.rowPath,
                        text: e.row.text,
                        value: e.row.value
                    },
                    rowIndex: e.rowIndex,
                    columnIndex: e.columnIndex,
                    columnFields: e.columnFields,
                    rowFields: e.rowFields,
                    dataFields: e.dataFields,
                    timestamp: Date.now()
                }
            });
        }
    }

    render() {
        return (
            <DXPivotGrid
                {...omit(['loading_state', 'setProps'], this.props)}
                onCellClick={this.props.onCellClick || this.onCellClick}
            />
        );
    }
}

PivotGrid.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,

    dataSource: PropTypes.object,

    // Dash supplied props
    setProps: PropTypes.func
};
